/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Irrigation_Sensors_StaleInputs */

const vi_irrigation_sensors_stale = /** @type {(inputs: Irrigation_Sensors_StaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số liệu đã cũ hơn ${i?.minutes} phút`)
};

/**

* @param {Irrigation_Sensors_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensors_stale = /** @type {((inputs: Irrigation_Sensors_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensors_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensors_stale(inputs)
});